import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse";
import Table from "react-bootstrap/Table";

function DeceasedDonorDataTable(props) {
    const [open, setOpen] = useState(false);
    return (
        <>
        <hr />
            <div className="collapse-container show-all-row">
            Show referrals and donors by donor hospital  &nbsp;&nbsp;
                <Button
                    onClick={() => setOpen(!open)}
                    aria-controls="collapse-text"
                    aria-expanded={open}
                    className="btn-dark-blue min-98"
                >
                    {!open && "Show All"}
                    {open && "Hide All"}
                </Button>
            </div>
            <Collapse in={open}>
                <div id="collapse-text" className="collapse-inner">
                    <Table striped className="overflow-auto description-of-donors-recovered-table">
                        <thead>
                            <tr>
                                <th className="text">
                                    Hospital Name (City, State)
                                </th>
                                <th className="text-center">
                                    Referrals
                                </th>
                                <th className="text-center">
                                    DBD Donors
                                </th>   
                                <th className="text-center">
                                    DCD Donors
                                </th>    
                                <th className="text-center">
                                    Total Donors
                                </th>   
                                <th className="text-center">
                                    Donors per 100 Referrals
                                </th>                                                                                             
                            </tr>
                        </thead>
                        <tbody>
                            {props.data.map((item, index) => (
                                <tr key={index}>
                                    <td className="text">{item.hospitaL_NAME}</td>
                                    <td className="text-center">{item.referrals}</td>
                                    <td className="text-center">{item.dbd}</td>
                                    <td className="text-center">{item.dcd}</td>
                                    <td className="text-center">{item.donors}</td>
                                    <td className="text-center">{item.crude_don_rate}</td>
                                </tr>
                            ))}                          
                        </tbody>
                    </Table>
                </div>
            </Collapse>
        </>
    );
}

export default DeceasedDonorDataTable;